import Header from "./Header";
import "./css/product.css";
import Product from "./Product";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ShoppingCart from "./ShoppingCart";
import commerce from "./lib/commerce"
import { useEffect, useState } from "react";
import Checkout from "./Checkout";
import Thankyou from "./Thankyou";

function App() {
  const [ productsList , setProductsList ] = useState([]);
  const [ productsListByCategory , setProductsListByCategory ] = useState([]);
  const [ categoryList , setCategoryList] = useState([]);
  const [cart,setCart] = useState([]);
  const [orderDetails,setOrderDetails]=useState({});
  
  const fetchProducts = async()=>{
  const response = await commerce.products.list();
  setProductsList(response.data);
  };
  const addToCart = async(prodId,qty)=>{
    const response = await commerce.cart.add(prodId,qty)
    setCart (response.cart)
    };

    const fetchCart =async()=>{
      setCart(await commerce.cart.retrieve())
    }
    const removeFromCart =async(prodId)=>{
      const response = await commerce.cart.remove(prodId);
      setCart(response.cart)
    }
    const fetchCategory= async()=>{
      const response = await commerce.categories.list();
      setCategoryList(response.data);
    }
    const fetchProductsByCategory= async(category)=>{
      const response = await commerce.products.list({
        category_slug:[category]
      });
      setProductsListByCategory(response.data);
    }

    const setOrder = async(order) =>{
      setOrderDetails(order)
    }

  useEffect(() => {
   fetchProducts();
   fetchCart();
   fetchCategory();
  }, [])
  return (
    <Router>
      <div className="App">
        <Header cart={cart} categoryList={categoryList}/>
        <Switch>
          <Route exact path="/">
            <div className="banner">
              <img
                src="https://m.media-amazon.com/images/I/71D7LpKHvfL._SX3000_.jpg"
                alt=""
              />
            </div>
             <Product productsList={productsList} addToCart={addToCart}  />
          </Route>

          <Route exact path="/cart">
            <ShoppingCart cart={cart} removeFromCart={removeFromCart}/>
          </Route>

          <Route exact path="/category/:slug">
            <div style={{marginBottom:"320px"}}></div>
          <Product productsList={productsListByCategory} fetchProductsByCategory={fetchProductsByCategory} addToCart={addToCart}  />
          </Route>
          <Route exact path="/checkout"  >
          <Checkout cart={cart} setOrder={setOrder} />
          </Route>

          <Route exact path="/thankyou">
           <Thankyou orderDetails={orderDetails}/>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
